export const defaultTransactionClientModel = {
  firstName: "",
  lastName: "",
  phonePrefix: "050",
  phoneNumber: "",
  email: "",
};
